import * as types from './types'

export const bootstrap = (payload) => ({
  type: types.BOOTSTRAP,
  payload,
})



// WEBPACK FOOTER //
// ./src/dynamic-list/redux/modules/bootstrap/actions.js